import React, { useEffect, useRef } from "react";
import { SiteHeader } from "@olympic/design-framework/react";

// The booking engine's header: the redesign's slim site header (design framework: logo, call centre number and hours
// from the CMS home page, GET /api/site-chrome) with Titan's "Edit Search" button, and under it - in the page column -
// the Olympic.Search widget, seeded with the current search.
const Header = ({ defaultSearch, hideSearch }) => {
    const searchContainerRef = useRef(null);

    // window.OlympicSearch is safe to call repeatedly for the same node - it
    // reuses the React root, so a defaultSearch change re-seeds the widget
    // rather than stacking a second root on the container.
    useEffect(
        function () {
            if (hideSearch) return;
            if (defaultSearch) {
                window.OlympicSearch({
                    mountNode: searchContainerRef.current,
                    baseUrl: window.searchUrl,
                    bookingEngineBaseUrl: "",
                    specificSearch: defaultSearch,
                });
            }
        },
        [defaultSearch, hideSearch]
    );
    return (
        <>
            <SiteHeader>
                {!hideSearch && (
                    <button
                        onClick={() => window.toggleSearchForm()}
                        type="button"
                        className="oly-btn oly-btn-primary oly-btn--small md:hidden"
                    >
                        Edit Search
                        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" aria-hidden="true">
                            <path
                                d="M11.8043 11.25L12.9293 12.375M13.2543 14.2689C12.821 13.8356 12.821 13.1332 13.2543 12.7C13.6875 12.2667 14.3899 12.2667 14.8232 12.7L16.3543 14.2311C16.7876 14.6644 16.7876 15.3668 16.3543 15.8C15.9211 16.2333 15.2187 16.2333 14.7854 15.8L13.2543 14.2689ZM12.9293 7.125C12.9293 4.22551 10.5788 1.875 7.67932 1.875C4.77983 1.875 2.42932 4.22551 2.42932 7.125C2.42932 10.0245 4.77983 12.375 7.67932 12.375C10.5788 12.375 12.9293 10.0245 12.9293 7.125Z"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            ></path>
                        </svg>
                    </button>
                )}
            </SiteHeader>
            {!hideSearch && (
                <div className="container px-6 mx-auto mt-6">
                    <div ref={searchContainerRef}></div>
                </div>
            )}
        </>
    );
};
export default Header;
